<template>
  <div class="tw-flex tw-w-full tw-items-start tw-gap-4">
    <div
      v-if="image"
      class="tw-flex tw-h-[60px] tw-w-[60px] tw-shrink-0 tw-items-center tw-justify-center"
    >
      <MediaImageLazyLoad
        :src="image"
        :alt="title"
        width="56px"
        height="56px"
        custom-class="tw-h-[56px] tw-w-[56px] tw-object-cover"
        seo-optimize
      />
    </div>
    <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-1">
      <h3
        class="tw-m-0 tw-text-mb-title-3 lg:tw-text-dt-title-3"
      >
        {{ title }}
      </h3>
      <p class="tw-m-0 tw-text-mb-body lg:tw-text-dt-body tw-text-dark-gray">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  image?: string;
  title: string;
  description: string;
}>();
</script>
